import { useEffect, useState } from 'react';

import { useCommentLike, useCommentReport, useCommentUnLike } from '.';
import { Comment as CommentType } from '../utils/backend-api/comments';

export default function useCommentActions(comment: CommentType) {
  const { mutate: reportComment } = useCommentReport(comment.id);

  // Tracks like delta when user likes/unlikes. Consider refreshing comment from api instead
  const [likeChange, setLikeChange] = useState(0);
  const { mutate: likeComment, isLoading: isLikeLoading } = useCommentLike(() =>
    setLikeChange((prev) => prev + 1)
  );

  const { mutate: unLikeComment, isLoading: isUnLikeLoading } = useCommentUnLike(() =>
    setLikeChange((prev) => prev - 1)
  );

  const toggleLike = () => {
    liked ? unLikeComment(comment.id) : likeComment(comment.id);
  };

  const report = () => {
    window.confirm(
      'Are you sure you want to report this comment to The Information staff as inappropriate?'
    ) && reportComment();
  };

  useEffect(() => {
    // Reset likeChange when comment gets refreshed.
    setLikeChange(0);
  }, [comment]);

  const liked = likeChange === 0 ? comment.current_user_likes : likeChange > 0;
  const likesCount = comment.likes_count + likeChange;
  const areLikesLoading = isLikeLoading || isUnLikeLoading;

  return { report, toggleLike, liked, likesCount, areLikesLoading };
}
